import {
  Container,
  Flex,
  Text,
  Box,
  Heading,
  Image
} from '@chakra-ui/react';

import { COLORS } from "../../../colors"
import React from 'react';

const Cursos = () => {
  return (
      <Container maxW="5xl" py={10} px={6}>
          <Flex justifyContent="center" mb={8} flexDirection='column' textAlign='center'>
              <Heading textAlign={"center"} as="h2" size="xl" mt={6} mb={2} fontFamily={"Montserrat"}>
                  Cursos intensivos de inglés de verano
              </Heading>
              <Text textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'} mb={4}>
                  Nuestros cursos intensivos están enfocados a prepararte en todas las partes del examen de Cambridge. ¡Mejora tus habilidades lingüísticas en un tiempo récord con nuestro enfoque especializado y profesores experimentados!
              </Text>
              <Flex 
                  justifyContent="center" 
                  alignItems="center" 
                  mt={8} 
                  flexDirection={{ base: 'column', md: 'row' }} // Cambia a columna en pantallas pequeñas
                  gap={20} // Espacio entre las imágenes
              >
                  <Image
                      src="/intensivob2.jpeg"
                      alt="Curso intensivo"
                      maxW="400px"
                  />
                  <Image
                      src="/intensivoc1.jpeg" // Asegúrate de tener la ruta correcta de la segunda imagen
                      alt="Otro curso intensivo"
                      maxW="400px"
                  />
              </Flex>
          </Flex>
      </Container>
  );
};

export default Cursos;
